import { BookItemType } from '../models/type';
import cover01 from '../../src/assets/img/books/cover_01.png';
import cover02 from '../../src/assets/img/books/cover_02.png';
import cover03 from '../../src/assets/img/books/cover_03.png';
import cover04 from '../../src/assets/img/books/cover_04.jpg';
import sentichemusica from '../../src/assets/img/books/sentichemusica.png';
import aspassotraipianeti from '../../src/assets/img/books/aspassotraipianeti.png';
import anicerex from '../../src/assets/img/books/anicerex.png';

export function useBook() {
  const booksCover: BookItemType[] = [
    {
      src: cover01,
      description: 'La passione LEGO® per principianti',
      edition: 'Ed. libri SANDIT - 2023',
      illustrator: 'Angelita Doria',
      author: 'Francesco Frangioja',
      externalUrl: '/passionelego',
    },
    {
      src: cover02,
      description: 'I robottoni giapponesi in mattoncini LEGO®',
      edition: 'Ed. libri SANDIT - 2024',
      illustrator: 'Angelita Doria',
      author: 'Francesco Frangioja',
      externalUrl: '/robot',
    },
    {
      src: cover03,
      description: 'La Formula 1 con i LEGO®',
      edition: 'Ed. libri SANDIT - 2025',
      illustrator: 'Angelita Doria',
      author: 'Francesco Frangioja',
      externalUrl: '/formulauno',
    },
    {
      src: cover04,
      description: 'I dinosauri con i LEGO®',
      edition: 'Ed. libri SANDIT - 2026',
      illustrator: 'Angelita Doria',
      author: 'Francesco Frangioja',
      externalUrl: '/dinosauri',
    },
  ];

  const books: BookItemType[] = [
    {
      src: sentichemusica,
      description: 'Senti che Musica!',
      edition: 'Ed. Splen edizioni - 2024',
      illustrator: 'Angelita Doria',
      externalUrl: '/sentichemusica',
    },
    {
      src: aspassotraipianeti,
      description: 'A spasso tra i pianeti',
      edition: 'Ed. Splen edizioni - 2025',
      author: 'Clelia Lombardo',
      illustrator: 'Angelita Doria',
      externalUrl: '/aspassotraipianeti',
    },
    {
      src: anicerex,
      description: 'Piccolo T-Rex va a scuola',
      edition: 'Ed. Splen edizioni - 2026',
      illustrator: 'Angelita Doria',
      externalUrl: '/anicerex',
    }
  ];

  return { booksCover, books };
}
